import React from 'react';
import { Mail, ArrowRight } from 'lucide-react';
import Navbar from '../components/Navbar.jsx';
import Footer from '../components/Footer.jsx';
import Seo from '../components/Seo.jsx';

const EMAIL = 'thedrunkenlectures@gmail.com';

const CAMPAIGN_STEPS = [
  <span>Reach out to us via : <a href={`mailto:${EMAIL}`} style={{ color: '#E8672E', textDecoration: 'none', fontWeight: '700' }}>{EMAIL}</a></span>,
  'Attach your campaign goals and what you would like to do',
  'We reach back with a concept that will make it happen',
  'Everything is umh, what do they say? possible!!',
];

const PRIVATE_STEPS = [
  <span>Reach out to us via : <a href={`mailto:${EMAIL}`} style={{ color: '#E8672E', textDecoration: 'none', fontWeight: '700' }}>{EMAIL}</a></span>,
  'Attach your proposal/problem for us to solve',
  'We will brain storm and share a concept with you, everything is tweakable with your people',
  'We host one hell of an event!!',
];

const offerings = [
  {
    tag: 'Campaigns',
    title: 'Campaign Partnerships',
    body: 'We have hosted campaigns across different intellectual capacities, campaigns to get you interested in things and we do it well. If you want to get through to your audience for your campaign, if you want to decentralise and have one on ones, If you think the drunken lecture audience is yout TA demographic, we can make it happen by hosting a very productive social environment:',
    steps: CAMPAIGN_STEPS,
  },
  {
    tag: 'Private Sessions',
    title: 'Private Sessions & Events',
    body: "Elevate your organisation's end of year party, team building experience, one on one b2b and B2C relations with a casual drunken lecture. We can do this with you, make productive sessions fun and calm.",
    steps: PRIVATE_STEPS,
  },
];

export default function Partnerships() {
  return (
    <div style={{
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      background: '#FFFFFF',
      minHeight: '100vh',
      margin: 0,
    }}>
      <Seo title="Partnerships" description="Partner with Drunken Lectures — sponsor a stage, back a festival, or bring your brand into the room." path="/partnerships" />
      <Navbar />

      {/* ── HERO ── */}
      <section style={{
        paddingTop: '100px',
        paddingBottom: '5rem',
        background: '#1C3A56',
        position: 'relative',
        overflow: 'hidden',
        textAlign: 'center',
      }}>
        {/* Subtle grain texture overlay */}
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(232, 103, 46,0.08) 0%, transparent 60%), radial-gradient(circle at 80% 20%, rgba(126,200,227,0.06) 0%, transparent 50%)',
          pointerEvents: 'none',
        }} />

        <div style={{ position: 'relative', zIndex: 1, maxWidth: '720px', margin: '0 auto', padding: '0 1.5rem' }}>
          <div style={{
            display: 'inline-block',
            background: 'rgba(232, 103, 46,0.15)',
            border: '1px solid rgba(232, 103, 46,0.35)',
            padding: '0.4rem 1.2rem',
            borderRadius: '50px',
            marginBottom: '1.75rem',
            fontSize: '0.72rem',
            fontWeight: '700',
            color: '#E8672E',
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
          }}>
            Partner With Us
          </div>

          <h1 style={{
            fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif",
            fontSize: 'clamp(2rem, 4vw, 3.5rem)',
            fontWeight: '600',
            color: 'white',
            lineHeight: 1.1,
            letterSpacing: '-0.02em',
            margin: '0 0 1.5rem',
          }}>
            We Decentralise and Reclaim<br />
            <span className="accent-underline" style={{ color: '#F0A576' }}>
              Bored/Board Rooms
            </span>
          </h1>

          <p style={{
            fontSize: 'clamp(1rem, 2vw, 1.2rem)',
            color: 'rgba(255,255,255,0.72)',
            lineHeight: 1.7,
            maxWidth: '560px',
            margin: '0 auto 2.5rem',
          }}>
            We can do this with you, your organisation, your friends, your campaign.
          </p>

          <a
            href="mailto:thedrunkenlectures@gmail.com"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.6rem',
              background: '#E8672E',
              color: 'white',
              padding: '0.95rem 2.1rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '700',
              fontSize: '0.95rem',
              boxShadow: '0 8px 28px rgba(232, 103, 46,0.38)',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 14px 36px rgba(232, 103, 46,0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 8px 28px rgba(232, 103, 46,0.38)';
            }}
          >
            <Mail size={17} />
            Hit Us Up
          </a>
        </div>
      </section>

      {/* ── WAVE DIVIDER ── */}
      <div style={{ background: '#1C3A56', lineHeight: 0 }}>
        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{ width: '100%', display: 'block' }}>
          <path d="M0,60 C360,0 1080,60 1440,0 L1440,60 Z" fill="#FFFFFF" />
        </svg>
      </div>

      {/* ── OFFERING CARDS ── */}
      <section style={{ padding: '5rem 1.5rem 6rem', maxWidth: '1200px', margin: '0 auto' }}>

        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <div style={{
            width: '48px', height: '3px',
            background: '#E8672E', borderRadius: '2px', margin: '0 auto 1.5rem',
          }} />
          <h2 style={{
            fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif",
            fontSize: 'clamp(1.8rem, 4vw, 3rem)',
            fontWeight: '600',
            color: '#17140F',
            letterSpacing: '-0.02em',
            lineHeight: 1.15,
            margin: 0,
          }}>
            What We Can Do Together
          </h2>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '2rem',
        }}>
          {offerings.map((offer, idx) => (
            <div
              key={idx}
              style={{
                background: 'white',
                borderRadius: '20px',
                padding: '2.5rem',
                boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
                border: '1px solid rgba(0,0,0,0.06)',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div style={{
                display: 'inline-block',
                background: 'rgba(232, 103, 46,0.1)',
                color: '#E8672E',
                fontSize: '0.7rem',
                fontWeight: '800',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                padding: '0.3rem 0.85rem',
                borderRadius: '50px',
                marginBottom: '1.25rem',
                alignSelf: 'flex-start',
              }}>
                {offer.tag}
              </div>

              <h3 style={{
                fontSize: '1.4rem',
                fontWeight: '800',
                color: '#17140F',
                marginBottom: '1rem',
                letterSpacing: '-0.02em',
                lineHeight: 1.25,
              }}>
                {offer.title}
              </h3>

              <p style={{
                fontSize: '0.95rem',
                color: '#5A5A5A',
                lineHeight: 1.7,
                marginBottom: '1.75rem',
              }}>
                {offer.body}
              </p>

              <div style={{
                background: '#F3EEE1',
                borderRadius: '12px',
                padding: '1.25rem 1.5rem',
                marginTop: 'auto',
              }}>
                <p style={{
                  fontSize: '0.72rem',
                  fontWeight: '700',
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                  color: '#8A8577',
                  marginBottom: '0.9rem',
                }}>
                  How it works
                </p>
                <ol style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.65rem' }}>
                  {offer.steps.map((step, i) => (
                    <li key={i} style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start' }}>
                      <span style={{
                        flexShrink: 0,
                        width: '22px', height: '22px',
                        background: '#E8672E',
                        color: 'white',
                        borderRadius: '50%',
                        fontSize: '0.7rem',
                        fontWeight: '800',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                      }}>
                        {i + 1}
                      </span>
                      <span style={{ fontSize: '0.88rem', color: '#3A3A3A', lineHeight: 1.55 }}>
                        {step}
                      </span>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA BAND ── */}
      <section style={{
        background: '#E8672E',
        padding: '5rem 1.5rem',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <h2 style={{
            fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif",
            fontSize: 'clamp(2rem, 5vw, 3rem)',
            fontWeight: '600',
            color: 'white',
            letterSpacing: '-0.02em',
            lineHeight: 1.1,
            margin: '0 0 2.25rem',
          }}>
            Hit us up !!!!
          </h2>
          <a
            href="mailto:thedrunkenlectures@gmail.com"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.6rem',
              background: 'white',
              color: '#E8672E',
              padding: '0.95rem 2.25rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '800',
              fontSize: '0.95rem',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#17140F';
              e.currentTarget.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'white';
              e.currentTarget.style.color = '#E8672E';
            }}
          >
            Book Us for a Private Session
            <ArrowRight size={17} />
          </a>
        </div>
      </section>

      <Footer />

      <style>{`
        * { box-sizing: border-box; }
        body { margin: 0; padding: 0; }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        a:focus-visible, button:focus-visible {
          outline: 2px solid #E8672E;
          outline-offset: 2px;
        }
      `}</style>
    </div>
  );
}
